import * as jose from 'jose'
var keys = require('./client.pem');

export class Live2dWebSDK {
    private static readonly domain = 'https://api.live2dweb.com';

    public static async VerifySignAPI(token: any) {
        const key = keys.default;
        const publicKey = await jose.importSPKI(key, 'RS256');
        const { payload } = await jose.jwtVerify(token.sign, publicKey);
        const response = await fetch(`${this.domain}/Verify`, {
            method: 'post',
            headers: new Headers({
                'Authorization': `Bearer ${token.sign}`,
                'Content-Type': 'application/x-www-form-urlencoded',
                'Extension-Id': token.extensionId
            }),
            body: `uid=${payload.certserialnumber}`
        });
        if (!response.ok) {
            return false;
        }
        const data = await response.text();
        const body = await this.DecodeJWToken(data);
        return body.payload.code == 200;
    }

    public static async DecodeJWToken(token: string, key: any = null) {
        if (key == null) {
            key = keys.default;
        }
        const publicKey = await jose.importSPKI(key, 'RS256');
        return await jose.jwtVerify(token, publicKey);
    }

}